// Importing with this method lazy loads the route. Better for performance

const AdminView = () => import('@/Admin/AdminView.vue')
const AdminAnalyticsPage = () => import('@/Admin/views/AnalyticsPage.vue')
const AdminHomePage = () => import('@/Admin/views/HomePage.vue')

const LibraryPage = () => import('@/Admin/views/Library/LibraryPage.vue')
const LibraryLiveEventsPage = () => import('@/Admin/views/Library/views/Events/views/LiveEventsPage.vue')
const LibraryLiveEventsDashboardPage = () => import('@/Admin/views/Library/views/Events/views/Dashboard/DashboardPage.vue')
const LibraryLiveEventsAudienceDashboardPage = () => import('@/Admin/views/Library/views/Events/views/Dashboard/AudienceDashboardPage.vue')
const LibraryVideosPage = () => import('@/Admin/views/VideosPage.vue')
const LibraryMicrositesPage = () => import('@/Admin/views/MicrositesPage.vue')
const LibraryPlaylistsPage = () => import('@/Admin/views/PlaylistsPage.vue')
const LibraryCheckpointsView = () => import('@/Admin/views/Library/views/Checkpoints/views/CheckpointsView.vue')
const LibraryCheckpointsEditView = () => import('@/Admin/views/Library/views/Checkpoints/views/EditCheckpoints.vue')

const SettingsPage = () => import('@/Admin/views/Settings/SettingsPage.vue')

const CreateNew = () => import('@/Admin/views/Create/views/CreateNew.vue')
const CreateSecurity = () => import('@/Admin/views/Create/views/CreateSecurity.vue')

const CreateEvent = () => import('@/Admin/views/Create/Events/views/CreateEvent.vue')
const CreateEventTitle = () => import('@/Admin/views/Create/Events/views/EventTitle.vue')
const CreateEventMetadata = () => import('@/Admin/views/Create/Events/views/EventMetadata.vue')
const CreateEventInteractives = () => import('@/Admin/views/Create/Events/views/EventInteractives.vue')
const CreateEventAddons = () => import('@/Admin/views/Create/Events/views/EventAddons.vue')
const CreateEventAddonsResources = () => import('@/Admin/views/Create/Events/views/EventAddonsResources.vue')
const CreateEventEnterpriseAddons = () => import('@/Admin/views/Create/Events/views/EventEnterpriseAddons.vue')
const CreateEventEnterpriseAddonsBreakoutRooms = () => import('@/Admin/views/Create/Events/views/EventEnterpriseAddonsBreakoutRooms.vue')
const CreateEventFinished = () => import('@/Admin/views/Create/Events/views/EventFinished.vue')

const ProfileView = () => import('@/Admin/views/Settings/views/ProfileView.vue')
const BrandingTemplatesView = () => import('@/Admin/views/Settings/views/BrandingTemplatesView.vue')

const routes = [
  {
    path: '/admin',
    name: 'admin',
    component: AdminView,
    redirect: to => {
      return '/admin/home'
    },
    children: [
      {
        path: 'analytics',
        name: 'adminAnalytics',
        component: AdminAnalyticsPage,
        meta: {
          title: 'Wirecast Events Analytics'
        }
      },
      {
        path: 'home',
        name: 'adminHome',
        component: AdminHomePage,
        meta: {
          title: 'Wirecast Events Home'
        }
      },
      {
        path: 'library',
        name: 'adminLibrary',
        component: LibraryPage,
        redirect: to => {
          return '/admin/library/events/all'
        },
        children: [
          {
            path: 'events/:folderId',
            name: 'libraryEvents',
            component: LibraryLiveEventsPage,
            meta: {
              title: 'Wirecast Events Live Events'
            }
          },
          {
            path: 'videos',
            name: 'libraryVideos',
            component: LibraryLiveEventsPage
          },
          {
            path: 'playlists',
            name: 'libraryPlaylists',
            component: LibraryLiveEventsPage
          },
          {
            path: 'microsites',
            name: 'libraryMicrosites',
            component: LibraryLiveEventsPage
          },
          {
            path: 'branding',
            name: 'libraryBranding',
            component: LibraryLiveEventsPage
          },
          {
            path: 'watermarks',
            name: 'libraryWatermarks',
            component: LibraryLiveEventsPage
          },
          {
            path: 'checkpoints',
            name: 'libraryCheckpoints',
            component: LibraryCheckpointsView
          },
          {
            path: 'checkpoints/edit/:checkpointId',
            name: 'editCheckpoint',
            component: LibraryCheckpointsEditView
          },
          {
            path: 'registration',
            name: 'libraryRegistration',
            component: LibraryLiveEventsPage
          },
          {
            path: 'metadata',
            name: 'libraryMetadata',
            component: LibraryLiveEventsPage
          }
        ]
      },
      {
        path: 'events/:id/dashboard',
        name: 'adminEventDashboard',
        component: LibraryLiveEventsDashboardPage,
        props: true,
        meta: {
          title: 'Wirecast Events | Dashboard'
        }
      },
      {
        path: 'events/:id/dashboard/audience',
        name: 'adminEventAudienceDashboard',
        component: LibraryLiveEventsAudienceDashboardPage,
        props: true,
        meta: {
          title: 'Wirecast Events | Dashboard'
        }
      },
      {
        path: 'create',
        redirect: to => {
          return '/create/new'
        },
        children: [
          {
            path: 'new',
            name: 'createNew',
            component: CreateNew
          },
          {
            path: 'live-event',
            component: CreateEvent,
            children: [
              {
                path: '',
                name: 'createEvent',
                component: CreateEventTitle
              },
              {
                path: 'metadata',
                name: 'createEventMetadata',
                component: CreateEventMetadata
              },
              {
                path: 'security',
                name: 'createEventSecurity',
                component: CreateSecurity
              },
              {
                path: 'interactives',
                name: 'createEventInteractives',
                component: CreateEventInteractives
              },
              {
                path: 'addons',
                name: 'createEventAddons',
                component: CreateEventAddons
              },
              {
                path: 'addons/resources',
                name: 'createEventAddonsResources',
                component: CreateEventAddonsResources
              },
              {
                path: 'enterprise-addons',
                name: 'createEventEnterpriseAddons',
                component: CreateEventEnterpriseAddons
              },
              {
                path: 'enterprise-addons/breakout-rooms',
                name: 'createEventEnterpriseAddonsBreakoutRooms',
                component: CreateEventEnterpriseAddonsBreakoutRooms
              },
              {
                path: 'finished',
                name: 'createEventFinished',
                component: CreateEventFinished
              }
            ]
          },
          {
            path: 'interactives',
            name: 'eventsCreateEventInteractives',
            component: CreateEventTitle
          }
        ]
      },
      {
        path: 'microsites',
        component: LibraryMicrositesPage,
        meta: {
          title: 'Wirecast Events Microsites'
        }
      },
      {
        path: 'playlists',
        component: LibraryPlaylistsPage,
        meta: {
          title: 'Wirecast Events Playlists'
        }
      },
      {
        path: 'settings',
        component: SettingsPage,
        meta: {
          title: 'Wirecast Events Settings'
        },
        children: [
          {
            path: 'profile',
            name: 'profileView',
            component: ProfileView
          },
          {
            path: 'branding-templates-view',
            name: 'brandingTemplatesView',
            component: BrandingTemplatesView
          }
        ]
      },
      {
        path: 'videos',
        component: LibraryVideosPage,
        meta: {
          title: 'Wirecast Events Videos'
        }
      }
    ]
  }
]

export default routes
